import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./Modal.css";

interface ModalWindowProps {
  show?: boolean;
  onHide?: () => void;
  heading?: string;
  body?: React.ReactNode;
  closeText?: string;
  [key: string]: any;
}

const ModalWindow: React.FC<ModalWindowProps> = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.body}</Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>
          {props.closeText ? props.closeText : "Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalWindow;
